export default {
  namespaced: true,
  log_incident: {
    title: "log incident | logs incidents",
    comment: "comment",
  },
};
